import * as e from "react";
import a from "../lib/IconBase.es.js";
import f from "../defs/CaretLeft.es.js";
const t = e.forwardRef((o, r) => /* @__PURE__ */ e.createElement(a, { ref: r, ...o, weights: f }));
t.displayName = "CaretLeftIcon";
const s = t;
export {
  s as CaretLeft,
  t as CaretLeftIcon
};
